import { useNavigate } from 'react-router-dom'
import { analyticsService } from '@meiuca/analytics'
import { Body, Caption } from '@meiuca/ui-components'
import { FileSignature } from 'lucide-react'
import { ANALYTICS_EVENTS } from '@/constants/analyticsEvents'
import type { TrainingCenterTermsItem } from '@/services/trainingCenterPlanService'

/**
 * Top-of-plans banners: one per student/center whose center asks for the
 * acceptance term and still lacks a signature of the current version
 * (`pending` or `outdated`). Each navigates to the public signing page.
 */
export function PendingTermsBanners({ items }: { items: TrainingCenterTermsItem[] }) {
  const navigate = useNavigate()
  const pending = items.filter((item) => item.terms.isEnabled && item.terms.status !== 'accepted')
  if (pending.length === 0) return null

  return (
    <div className="space-y-3 mb-6">
      {pending.map((item) => {
        const { terms } = item
        const isOutdated = terms.status === 'outdated'
        const signer = terms.isSignedByGuardian
          ? `do responsável (${terms.signerDisplayName})`
          : 'cadastrado'
        return (
          <button
            key={`${item.trainingCenter.id}-${item.studentCustomer.id}`}
            type="button"
            onClick={() => {
              analyticsService.track(ANALYTICS_EVENTS.CONTRACT_TERMS_BANNER_CLICKED, {
                training_center_id: item.trainingCenter.id,
                status: terms.status
              })
              navigate(`/terms/${terms.publicToken}`)
            }}
            className="w-full rounded-2xl bg-background-white shadow-sm border border-feedback-warning/40 px-5 py-4 flex items-center gap-3 text-left hover:shadow-md transition-shadow"
          >
            <FileSignature className="w-5 h-5 text-feedback-warning flex-shrink-0" />
            <span className="min-w-0 flex-1">
              <Body className="text-sm font-semibold text-text-primary m-0">
                {isOutdated ? 'Termo atualizado — assine a nova versão' : 'Termo de aceite pendente'}
              </Body>
              <Caption className="text-text-secondary">
                {item.trainingCenter.name}
                {item.isDependent ? ` · Aluno: ${item.studentCustomer.name}` : ''}. O código vai para o
                telefone {signer}.
              </Caption>
            </span>
            <span className="text-brand-primary text-sm font-medium flex-shrink-0">Assinar</span>
          </button>
        )
      })}
    </div>
  )
}
